<template>
  <div
    v-show="!content.hide"
    @click.prevent="getStoryblokLink(content.link, target(content.link.linktype))"
    v-if="content"
    class="parc-menu-item"
  >
    <img :src="content.img" :alt="content.title">
    <h2 class="title-font" v-html="content.title"></h2>
    <a
      @click.prevent="getStoryblokLink(content.link, target(content.link.linktype))"
      class="link"
      :target="target(content.link.linktype)"
    >
      <fai class="icon" icon="chevron-right"></fai>
    </a>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  methods: {
    target(type) {
      if (type == "url") {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
$radius: 15px;
.parc-menu-item {
  background-color: #fff;
  max-width: 300px;
  margin: auto;
  padding: 0px;
  border-radius: $radius;
  cursor: pointer;
  position: relative;
  &:hover {
    img {
      transform: scale(1.2) translateY(-10px);
    }
    .link {
      .icon {
        transform: translateX(10px);
      }
    }
  }
  h2 {
    color: $primary;
    font-size: 20px;
    text-align: center;
    padding: 0.5em 0;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    width: 40%;
    height: auto;
    margin: auto;
    margin-top: calc(-40% + 30px);
    transform: scale(1) translateY(0);
    transition: transform 0.4s;
  }
  .link {
    width: 100%;
    background-color: $primary;
    color: #fff;
    padding: 15px 0;
    display: block;
    text-align: center;
    font-weight: bold;
    border-bottom-left-radius: $radius;
    border-bottom-right-radius: $radius;
    .icon {
      font-size: 20px;
      transform: translateX(0);
      transition: transform 0.4s;
    }
    &:hover {
      background-color: $primary-D;
    }
  }
}
</style>
